/**
 * @class ServerSubstitutionKeywordsStringAssets A collection of string assets provide keywords that will be substituted on the server (generally used for email messages)
 */
export class ServerSubstitutionKeywordsStringAssets {
   static AppUrl = "%APP_URL%";
   static EmailVerificationLink = "%EMAIL_VERIFICATION_LINK%";
   static LogoUrl = "%LOGO_URL%";
   static PasswordResetLink = "%PASSWORD_RESET_LINK%";
   static ProjectName = "%PROJECT_NAME%";
   static SignInWithEmailLink = "%SIGN_IN_WITH_EMAIL_LINK%";
}